const isValidWaitingTime = (item: any, key: string = 'waitingTime') => {
  return !Number.isNaN(item[key]) && !Number.isNaN(item.allowableWaittingTime) && item[key] > item.allowableWaittingTime
}

export { isValidWaitingTime }
